import React from "react";
import { CardMedia } from '@mui/material';

const Screenshots = () => {
    console.log('screenshots')

    return (
        <React.Fragment>
            <CardMedia
                image={'https://tirefax.s3.us-west-2.amazonaws.com/screenshots/withtiretrax/mobile/01-login.png'}
                sx={{
                    marginTop: "120px",
                    width: "450px",
                    height: "250px"
                }}
                width={400}


                alt="logo"
            />
        </React.Fragment>
    );
}

export default Screenshots;